/* @flow */
import React, { Component } from 'react';
import { isBrowsersOptimal } from '../../base/environment/environment';
import { translate } from '../../base/i18n/functions';
// @ts-ignore
import { CHROME, FIREFOX } from './browserLinks';
/**
 * The namespace of the CSS styles of UnsupportedDesktopBrowser.
 *
 * @private
 * @type {string}
 */
const _SNS = 'unsupported-desktop-browser';
/**
 * React component representing unsupported browser page.
 *
 * @class UnsupportedDesktopBrowser
 */
class UnsupportedDesktopBrowser extends Component {
    /**
     * Renders the component.
     *
     * @returns {ReactElement}
     */
    render() {
        return (React.createElement("div", { className: _SNS },
            React.createElement("div", { className: 'unsupported-browser-content' },
                React.createElement("img", { src: 'images/unsupported-browser/logo.png' }),
                React.createElement("span", { className: 'unsupported-browser-title' }, "Our meeting leverages best-of-breed WebRTC and the browser you are using doesn't support it"),
                React.createElement("span", { className: 'unsupported-browser-subtitle' },
                    "Try the latest version of\u00A0",
                    React.createElement("a", { className: 'unsupported-browser-link', href: CHROME, rel: 'noopener noreferrer', target: '_blank' }, "Chrome"),
                    this._showFirefox()
                        && React.createElement(React.Fragment, null,
                            "\u00A0or\u00A0",
                            React.createElement("a", { className: 'unsupported-browser-link', href: FIREFOX, rel: 'noopener noreferrer', target: '_blank' }, "Firefox"))),
                React.createElement("div", { className: 'unsupported-browser-separator' }),
                React.createElement("span", { className: 'unsupported-browser-footer' },
                    "Are you looking for\u00A0",
                    React.createElement("a", { className: 'unsupported-browser-link', href: 'https://www.8x8.com/products/apps', rel: 'noopener noreferrer', target: '_blank' }, "8x8 Work?")))));
    }
    /**
     * Returns whether or not a link to download Firefox is displayed.
     *
     * @private
     * @returns {boolean}
     */
    _showFirefox() {
        return isBrowsersOptimal('firefox');
    }
}
export default translate(UnsupportedDesktopBrowser);
